import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { createConnectedWalletController } from './connected-wallet-controller.js';
export function useConnectedWalletCapability(client, surface, t0) {
  const $ = _c(11);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== client.cacheKey || $[1] !== surface) {
    t1 = ["onramp", client.cacheKey, "connected-wallet-capability", surface];
    $[0] = client.cacheKey;
    $[1] = surface;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== client.connectedWallet || $[4] !== surface) {
    t2 = t3 => {
      const {
        signal
      } = t3;
      return client.connectedWallet?.capability(surface, signal) ?? Promise.resolve(false);
    };
    $[3] = client.connectedWallet;
    $[4] = surface;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      persist: false
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== enabled || $[8] !== t1 || $[9] !== t2) {
    t4 = {
      queryKey: t1,
      enabled,
      queryFn: t2,
      retry: false,
      staleTime: 60000,
      gcTime: 60000,
      meta: t3
    };
    $[7] = enabled;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return useQuery(t4);
}
export function useConnectedWallet(client, options) {
  const $ = _c(36);
  const {
    surface,
    locale,
    active,
    operationId,
    createId,
    onComplete,
    autoStart: t0
  } = options;
  const autoStart = t0 === undefined ? false : t0;
  const t1 = operationId ?? null;
  let t2;
  if ($[0] !== client || $[1] !== createId || $[2] !== locale || $[3] !== surface || $[4] !== t1) {
    t2 = createConnectedWalletController(client, surface, locale, createId, t1);
    $[0] = client;
    $[1] = createId;
    $[2] = locale;
    $[3] = surface;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const actions = t2;
  const state = useSyncExternalStore(actions.subscribe, actions.getSnapshot, actions.getSnapshot);
  let t3;
  if ($[6] !== actions.dispose || $[7] !== client) {
    t3 = () => client.onDispose(actions.dispose);
    $[6] = actions.dispose;
    $[7] = client;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== actions || $[10] !== client) {
    t4 = [client, actions];
    $[9] = actions;
    $[10] = client;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[12] !== actions || $[13] !== onComplete) {
    t5 = () => {
      if (!onComplete) {
        return;
      }
      return actions.onComplete(onComplete);
    };
    t6 = [actions, onComplete];
    $[12] = actions;
    $[13] = onComplete;
    $[14] = t5;
    $[15] = t6;
  } else {
    t5 = $[14];
    t6 = $[15];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[16] !== actions || $[17] !== active || $[18] !== operationId || $[19] !== state.operation) {
    t7 = () => {
      if (active && operationId && !state.operation) {
        actions.resume(operationId);
      }
    };
    t8 = [actions, active, operationId, state.operation];
    $[16] = actions;
    $[17] = active;
    $[18] = operationId;
    $[19] = state.operation;
    $[20] = t7;
    $[21] = t8;
  } else {
    t7 = $[20];
    t8 = $[21];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[22] !== actions || $[23] !== active || $[24] !== autoStart || $[25] !== operationId) {
    t9 = () => {
      if (active && autoStart && !operationId && !actions.getSnapshot().operation) {
        actions.start();
      }
    };
    t10 = [actions, active, autoStart, operationId];
    $[22] = actions;
    $[23] = active;
    $[24] = autoStart;
    $[25] = operationId;
    $[26] = t10;
    $[27] = t9;
  } else {
    t10 = $[26];
    t9 = $[27];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[28] !== actions || $[29] !== active || $[30] !== state.operation) {
    t11 = () => {
      const operation = state.operation;
      if (!active || !operation || ["complete", "route_failed", "refund"].includes(operation.state)) {
        return;
      }
      const timer = setInterval(() => void actions.refresh(), 7000);
      return () => clearInterval(timer);
    };
    t12 = [actions, active, state.operation];
    $[28] = actions;
    $[29] = active;
    $[30] = state.operation;
    $[31] = t11;
    $[32] = t12;
  } else {
    t11 = $[31];
    t12 = $[32];
  }
  useEffect(t11, t12);
  let t13;
  if ($[33] !== actions || $[34] !== state) {
    t13 = {
      state,
      actions
    };
    $[33] = actions;
    $[34] = state;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}